export interface Driver {
	type: string;
	firstName: string;
	lastname: number;
	cardId: string;
}

export enum CARD_ISSUER {
	NO_INFORMATION = 'NO_INFORMATION',
	DE = 'DE'
}

export enum SOCKET_REQUEST_TYPE {
	DRIVER_INFO = 'driver-info',
	CARD_STATUS = 'card-status',
	DLK_STATUS = 'dlk-status'
}

export enum SOCKET_RESPONSE_TYPE {
	DRIVER_INFO = 'driver-info',
	DLK_STATUS = 'dlk-status',
	CARD = 'CARD',
	RFID = 'RFID',
	ERROR = 'error'
}

export interface SocketMessage {
	type: string;
	[key: string]: any;
}

export interface CardStatusMessage extends SocketMessage {
	cardPresent: boolean;
}

export interface DlkStatusMessage extends SocketMessage {
	dlkConnected: boolean;
}

export interface DriverInfoMessage extends SocketMessage {
	driverCardDriverId: string;
	driverCardIssuer: CARD_ISSUER;
	firstActivityTime: string | null;
	id: string;
	firstName: string;
	lastName: string;
}

export interface ErrorMessage extends SocketMessage {
	code: string;
}
